var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('TheSidebar'),_c('div',{staticClass:"audits-completed col-md-12"},[_c('TheHeader',{attrs:{"headerType":"logo"}}),_vm._t("default")],2)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }